import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { API } from '@aws-amplify/api';
import Amplify from '@aws-amplify/core';
import 'hammerjs';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { BrowserTracing } from '@sentry/tracing';

import { environment } from './environments/environment.develop';
import * as version from './version.json';

const AUTH_DOMAIN_PRODUCTION = 'auth.learnwith.ai';
const AUTH_DOMAIN_DEVELOPMENT = 'alphacdk-{{env}}-oauth.rp.devfactory.com';
const AUTH_DOMAIN =
  environment.aws_env === 'production'
    ? AUTH_DOMAIN_PRODUCTION
    : AUTH_DOMAIN_DEVELOPMENT.replace('{{env}}', environment.aws_env);

Sentry.init({
  dsn: environment.sentryID,
  environment: environment.mode,
  release: version.version,
  integrations: [
    new BrowserTracing({
      tracePropagationTargets: ['localhost', environment.productUrl],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],

  tracesSampleRate: 1.0,
});

Amplify.configure({
  ...environment,
  oauth: {
    domain: AUTH_DOMAIN,
    scope: ['email', 'profile', 'aws.cognito.signin.user.admin', 'openid'],
    redirectSignIn: `${window.location.origin}/auth/login`,
    redirectSignOut: `${window.location.origin}/auth/login`,
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
});
API.configure(environment);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
